import { render, staticRenderFns } from "./InventoryTransactionDetails.vue?vue&type=template&id=2f306151&"
import script from "./InventoryTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./InventoryTransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports